import EmptyStateBackgroundImage from '@assets/images/themeDependent/empty-state_background-fade-dark.png';
import ExampleCheckEN from '@assets/images/themeDependent/example-check-image-dark-en.png';
import ExampleCheckES from '@assets/images/themeDependent/example-check-image-dark-es.png';
import WorkspaceProfile from '@assets/images/workspace-profile.png';
import type IllustrationsType from '@styles/theme/illustrations/types';

const illustrations = {
    EmptyStateBackgroundImage,
    ExampleCheckEN,
    ExampleCheckES,
    WorkspaceProfile,
} satisfies IllustrationsType;

export default illustrations;
